import { DateRangeFilter } from '@cast/shared-date-ui';

export const defaultFilterPresets: DateRangeFilter[] = [
  DateRangeFilter.Last7Days,
  DateRangeFilter.Last2Weeks,
  DateRangeFilter.Last30Days,
  DateRangeFilter.ThisMonth,
  DateRangeFilter.PreviousWeek,
  DateRangeFilter.PreviousMonth,
];

export const shortRangeFilterPresets: DateRangeFilter[] = [
  DateRangeFilter.Today,
];

export const reliabilityFilterPresets: DateRangeFilter[] = [
  DateRangeFilter.Last15Mins,
  DateRangeFilter.Last30Mins,
  DateRangeFilter.LastHour,
  DateRangeFilter.Last6Hours,
  DateRangeFilter.Last24Hours,
  ...defaultFilterPresets,
];

export const workloadsTableKey = 'workloads-cost-report';
export const namespacesTableKey = 'namespaces-cost-report';

export const chartColors = {
  provisioned: 'blue.600',
  requested: 'blue.300',
  used: 'green.100',
};

export const LIST_PRICE_QUERY_PARAM = 'cost_report_price_type';

export const IDLE_COSTS_QUERY_PARAM = 'cost_report_idle_costs';

export const MANAGED_ONLY_QUERY_PARAM = 'cost_report_managed_only';

export const LIST_PRICE_COLLECTION_START_DATE = '2025-08-06';
